module.exports = require('./helpers/bundle-url').getBundleURL('9E8ze') + "logo-dark.eefe0b7f.svg";